import Header from "components/Header";
import { HeaderAfterLogin } from "components/HeaderAfterLogin";
import StudentHeader from "components/StudentHeader";
import { useSelector } from "react-redux";
import { currentToken, currentUserData } from "redux/reducers/token";

const MainHeader = () => {
  const token = useSelector(currentToken);
  const userData = useSelector(currentUserData);

  // Determine header based on user role and state
  const renderHeader = () => {
    if (token) {
      switch (userData.roleType) {
        case "student":
          return <StudentHeader />;
        default:
          return userData.regStep !== 5 ? <Header /> : <HeaderAfterLogin />;
      }
    }
    return <Header />;
  };

  return <>{renderHeader()}</>;
};

export default MainHeader;
